module.exports = __webpack_public_path__ + "static/media/mu.5a584a2b.svg";